export default "__VITE_ASSET__DaSOYHOo__"